<nav>
  <div class="flex-row">
    <div class="flex-1">
      <div class="logo">
        <a routerLink="/" >
          <img alt="" src="./assets/images/Healthineers_logo.png">

        </a>
      </div>
    </div>

    <div class="flex-row flex-1 nav-right">

      <ul class="flex-row nav-bar">
        @if (profile() && profile()!.role != 'None') {
          <li><a routerLink="inspectors" routerLinkActive="nav-active"> Inspectors </a></li>
        }
        @if (profile() && profile()!.role == 'Admin') {
          <li><a routerLink="suppliers" routerLinkActive="nav-active"> Suppliers </a></li>
        }
        @if (profile() && profile()!.role == 'Admin') {
          <li><a routerLink="users" routerLinkActive="nav-active"> Employees </a></li>
        }
      </ul>

      @if (profile()?.user) {
        <div class="flex-1 user">
          <!-- <a routerLink="/account"> -->
          <div class="user-details">
            @if (profile()) {
              <p class="text-small ">{{profile()!.user!.firstName}} {{profile()!.user!.surName}}</p>
            }
            @if (profile()) {
              <p class="text-small ">({{profile()!.user!.department}})</p>
            }
            @if (profile()) {
              <p class="text-small">{{ profile()!.role }}</p>
            }
          </div>
        <!-- </a> -->
      </div>
    }

  </div>

</div>
</nav>
